import { supabase } from '../../../services/supabaseClient';

const TABLE = 'bianca_realestate_email_templates';
const MF_TOKEN = 'QOQMRWtDQA9W8pluLNSV';

export async function listTemplates() {
  const { data, error } = await supabase
    .from(TABLE)
    .select('*')
    .eq('token', MF_TOKEN)
    .order('updated_at', { ascending: false });
  if (error) return { ok: false, error: error.message };
  return { ok: true, items: data || [] };
}

export async function createTemplate({ nome, subject, html, from_addr, reply_to, created_by }) {
  const payload = {
    token: MF_TOKEN,
    nome: (nome || '').trim(),
    subject: subject || null,
    html: html || null,
    from_addr: from_addr || null,
    reply_to: reply_to || null,
    created_by: created_by || null,
  };
  const { data, error } = await supabase
    .from(TABLE)
    .insert(payload)
    .select('*')
    .single();
  if (error) return { ok: false, error: error.message };
  return { ok: true, item: data };
}

export async function updateTemplate(id, patch) {
  const allowed = ['nome', 'subject', 'html', 'from_addr', 'reply_to'];
  const cleanPatch = Object.fromEntries(
    Object.entries(patch).filter(([k]) => allowed.includes(k))
  );
  cleanPatch.updated_at = new Date().toISOString();
  const { data, error } = await supabase
    .from(TABLE)
    .update(cleanPatch)
    .eq('id', id)
    .eq('token', MF_TOKEN)
    .select('*')
    .single();
  if (error) return { ok: false, error: error.message };
  return { ok: true, item: data };
}

export async function deleteTemplate(id) {
  const { error } = await supabase
    .from(TABLE)
    .delete()
    .eq('id', id)
    .eq('token', MF_TOKEN);
  if (error) return { ok: false, error: error.message };
  return { ok: true };
}

export async function markTemplateSent(id, runId, totalRecipients) {
  const { error } = await supabase
    .from(TABLE)
    .update({
      ultimo_envio_at: new Date().toISOString(),
      ultimo_run_id: runId || null,
    })
    .eq('id', id)
    .eq('token', MF_TOKEN);
  if (error) return { ok: false, error: error.message };
  return { ok: true };
}
